import { getConfig } from '../../configs/config';
import { ADSBehaviour } from '../../constants';
import messages from '../../constants/logMessages.json';
import {
  CheckBoxPayload,
  ClickPayload,
  EngagementTrackingPayload,
  inputFieldPayload,
  OnShowPayload,
} from '../../types/designSystem';
import logging, { getMessage } from '../logging';
import {
  buttonAndLinkHandler,
  datePickerButtonHandler,
  showAndCloseHandler,
} from './clickTracking';
import {
  changeInputFieldHandler,
  checkInputFieldHandler,
  datePickerChangeSelectHandler,
} from './inputFieldTracking';
import { datePickerOnShowHandler, onShowHandler } from './onShowTracking';

const {
  infoHeading,
  // warnHeading,
  errorHeading,
  infoBold,
  // warnBold,
  errorBold,
} = messages;

const componentTypeHandler = (payload: EngagementTrackingPayload) => {
  const { componentType, trackProps } = payload;
  const { behaviour = '' } = trackProps;
  if (!componentType)
    throw new Error('Site Tracking invalid: componentType is required');

  switch (componentType) {
    case 'button':
    case 'buttonGroup':
    case 'link':
    case 'chip':
    case 'chipGroup':
    case 'fab':
    case 'form':
    case 'progressButton':
    case 'box':
    case 'stepper':
    case 'appBar':
    case 'action':
    case 'card':
      // TODO
      // Further logic for Click Tracking.
      buttonAndLinkHandler(payload as ClickPayload);
      break;
    case 'textField':
    case 'dropDown':
    case 'formElement':
    case 'slider':
    case 'toggle':
    case 'radio':
    case 'radioBase':
    case 'radioGroup':
      changeInputFieldHandler(payload as inputFieldPayload);
      break;
    case 'checkBox':
    case 'checkBoxBase':
    case 'checkBoxGroup':
    case 'checkBoxParent':
    case 'switch':
    case 'switchGroup':
      checkInputFieldHandler(payload as CheckBoxPayload);
      break;
    case 'drawer':
    case 'accordion':
    case 'overlay':
    case 'snackbar':
    case 'modal':
    case 'helperText':
      showAndCloseHandler(payload as ClickPayload);
      break;
    case 'alert':
      onShowHandler(payload as OnShowPayload);
      break;
    case 'datePicker':
      switch (behaviour) {
        case ADSBehaviour.TEXTCHANGE:
          changeInputFieldHandler(payload as inputFieldPayload);
          break;
        case ADSBehaviour.SHOWWIDGET:
        case ADSBehaviour.CLOSEWIDGET:
        case ADSBehaviour.SHOWYEAR:
        case ADSBehaviour.CLOSEYEAR:
          datePickerOnShowHandler(payload as inputFieldPayload);
          break;
        case ADSBehaviour.SELECTDAY:
        case ADSBehaviour.SELECTMONTH:
        case ADSBehaviour.SELECTYEAR:
          datePickerChangeSelectHandler(payload as inputFieldPayload);
          break;
        case ADSBehaviour.CONFIRMATION:
          datePickerButtonHandler(payload as inputFieldPayload);
          break;
        default:
          return false;
      }
      break;
    default:
      logging.error(
        getMessage('adsNoEngagementTrackingSupport', [componentType]),
        errorHeading,
        errorBold
      );
      return false;
  }
  return false;
};

// Design System Init
const engagementTracking = (payload: EngagementTrackingPayload) => {
  // TODO setup design system payload suppression.

  const { analytics, componentType } = payload;
  const { enableAdsEngagementTracking = 'true' } = getConfig();

  if (analytics && /^isDisabled$/i.test(analytics)) {
    logging.info(
      getMessage('adsAnalyticsDisabled', [componentType]),
      infoHeading,
      infoBold
    );
    return;
  }

  // ADS Suppress - enableAdsEngagementTracking  is set to "false" and "analytics" props is falsey
  if (!enableAdsEngagementTracking && !analytics) {
    logging.info(
      getMessage('enableAdsEngagementTrackingDisabled'),
      infoHeading,
      infoBold
    );
    return;
  }

  // ADS Suppress is on, but "analytics" is enabled for this particular component
  if (!enableAdsEngagementTracking && analytics === 'isEnabled') {
    logging.info(getMessage('adsAnalyticsOverride'), infoHeading, infoBold);
  }

  // Default behaviour for generic click components to be track, even without analytics isEnabled.
  // if (!analytics && !defaultEnableComponents.test(componentType)) {
  //   logging.info(getMessage('adsAnalyticsComponentDisabled'), infoHeading, infoBold);
  //   return;
  // }
  componentTypeHandler(payload);
};

export default engagementTracking;
